/**
 * Der kurze Datenschutzhinweis am Score-Absende-Punkt (BL-96).
 *
 * **Warum das eine eigene Datei ist (B31, 2026-08-15).** Diese zwei Sätze
 * standen in `legalContent.ts`. `PreRunScreen.ts` importierte sie von dort —
 * und zog damit den **gesamten Rechtstext-Korpus** in den Startup-Chunk:
 * `legalContent.ts` (8,5 kB) plus das von ihm importierte `attributions.ts`
 * (9,6 kB), zusammen ~18 kB roh, für eine Konstante von zwei Strings.
 *
 * Das ist die klassische Zufallsabhängigkeit: ein winziger Import hält einen
 * grossen Baum am Leben. Gemessen über die Sourcemap des Builds, nicht geraten.
 *
 * Die Regel dahinter, falls hier je etwas dazukommt: **was der erste Frame
 * braucht, gehört in diese Datei — alles andere in `legalContent.ts`.** Ein
 * neuer Import von `legalContent.ts` in einen Startup-Pfad macht die
 * Entlastung sofort wieder zunichte.
 */
export const SUBMIT_PRIVACY_NOTICE = {
  en: "When online scores are on, submitting publishes your 3-letter initials, score, wave, operator and threat level to the global leaderboard, with a random play ID. No account, name or email. See the Privacy Policy.",
  de: "Bei aktivierten Online-Bestenlisten werden mit dem Absenden deine 3-Buchstaben-Initialen, Punkte, Welle, Operator und Bedrohungsstufe samt einer zufälligen Spiel-ID an die globale Bestenliste übertragen. Kein Konto, kein Name, keine E-Mail. Siehe Datenschutzerklärung.",
} as const;
